module.exports = "/img/_/_/_/assets/images/creeper/book/common//42.jpg?7b236d2962044a78a3629df66fc51cdb";